import globalData from './globalData'
export const setupGlobalProperties = (app) => {
  app.config.globalProperties.$globalData = globalData
}
